import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getHeaders } from 'src/common';
import { SERVER_API } from 'src/config';
import i18n from 'src/i18n';
import { useModal } from 'src/providers/Modal';
import LanguageChanger from './LanguageChanger';
import './popup-announcement.css';

export function PopUp() {
  const { t } = useTranslation();
  const [modalContent, setModalContent] = useState(`<h2 class="text-center">${t('loading')}...</h2>`);
  const [modalTitle, setModalTitle] = useState('...');
  const [popup, setPopup] = useState({ id: null });
  const [popups, setPopups] = useState([]);
  const [visible, setVisible] = useState(false);

  const setNextPopup = (popups) => {
    console.log('next popup');
    while (popups.length > 0) {
      const popup = popups.shift();
      console.log({ popup });

      if (popup.id > parseInt(localStorage.getItem('popup_id') ?? '0')) {
        setPopup(popup);
        setPopups(popups);
        break;
      }
    }
  };
  useEffect(() => {
    const popup_id = localStorage.getItem('popup_id') ?? 0;
    axios
      .post(
        `${SERVER_API}popup/active_popup`,
        { popup_id, lang: i18n.resolvedLanguage },
        { headers: getHeaders() },
      )
      .then((response) => {
        console.log(response.data.result);
        if (response.data.result && response.data.result.length > 0) {
          setPopups(response.data.result);
          setNextPopup(response.data.result);
        }
      })
      .catch((error) => {
        console.error('Error fetching modal content:', error);
      });
  }, []);

  const translatedPopup = (popup) => {
    if (i18n.resolvedLanguage === 'az') {
      const ap = popup?.translate?.find((i) => i.lang === 'AZE');
      return { title: ap?.title ?? popup.title, content: ap?.content ?? popup.content };
    } else if (i18n.resolvedLanguage === 'ru') {
      const rp = popup?.translate?.find((i) => i.lang === 'RUS');
      return { title: rp?.title ?? popup.title, content: rp?.content ?? popup.content };
    }
    return popup;
  };

  useEffect(() => {
    if (!popup || !popup.id) return;
    const { title, content } = translatedPopup(popup);
    setModalTitle(title);
    setModalContent(content);

    localStorage.setItem('popup_id', popup.id);
    setVisible(true);
  }, [popup.id, i18n.resolvedLanguage]);

  return (
    <CModal
      visible={visible}
      alignment='center'
      size='lg'
      className='oc-announcement-modal'
      onClose={() => setVisible(false)}
    >
      <CModalHeader className='oc-announcement-modal__header align-items-center' closeButton>
        <CModalTitle className='oc-announcement-modal__title flex-grow-1'>{modalTitle}</CModalTitle>
        <span>
          <LanguageChanger />
        </span>
      </CModalHeader>
      <CModalBody
        className='oc-announcement-modal__body'
        dangerouslySetInnerHTML={{ __html: modalContent }}
      >
        {/* <iframe src={`${SERVER_API}popup/${i18n.resolvedLanguage}/notification-1.html`} width='100%' height='100%' /> */}
        {/* <div dangerouslySetInnerHTML={{__html: modalContent}}></div> */}
      </CModalBody>
      <CModalFooter className='oc-announcement-modal__footer'>
        {popups?.length > 0 ? (
          <CButton color='primary' onClick={() => setNextPopup(popups)}>{t('next')}</CButton>
        ) : (
          <CButton color='primary' onClick={() => setVisible(false)}>{t('close')}</CButton>
        )}
      </CModalFooter>
    </CModal>
  );
}
